<template>
  <div class="brandStoreIndexPage">
    <XR-head :rightShow="true" ref="head"></XR-head>
    <div class="banner-area">
        <div class="banner-list">
            <img :src="templateInfo.BannerImg" />
        </div>
    </div>
    <div class="main-area">
        <div class="button-list">
            <img :src="templateInfo.BtnListImg" class="button" />
        </div>
        <div class="model about">
            <img :src="templateInfo.About1Img" />
        </div>
        <div class="model product">
            <img :src="templateInfo.Product1Img" />
            <img :src="templateInfo.Product2Img" />
            <img :src="templateInfo.Product3Img" />
        </div>        
        
        <div class="model product-row">
            <template v-for="(proItem,index) in templateInfo.Products">
              
              <div :class="'product-item '+ (index%2==0?'':'right')" :key="index">
                  <div class="content">
                      <img :src="proItem.DefaultImage" :style="{height:imgWidth+'px'}" />
                      <p class="name">{{ getProductName(proItem) }}</p>
                      
                      <router-link :to="'/retail/productDetail?skuId='+ proItem.SkuId" class="link-btn">立即购买</router-link>
                  </div>
              </div>
            </template>
        </div>

        <div class="model about">
            <img :src="templateInfo.About2Img" />
        </div>
        <div class="model lianxi">
            <img :src="templateInfo.LianXiImg" />
        </div>
        <div class="model">
            <router-link :to="'/shop/shopIndex?shopId='+ templateInfo.ShopId" class="btn-shop">进入{{templateInfo.ShopName}}</router-link>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      templateInfo:{},
      shopId: this.$route.query.shopId ? this.$route.query.shopId : this.$route.query.shopid,
      imgWidth: document.documentElement.clientWidth / 2 * 0.98
    }
  },
  props:{
    titleText: String,
   
  },
  mounted(){
    var url = window.location.href
    if(/[?]from=(.)*#/.test(url)){
      url = url.replace(/[?]from=(.)*#/g , "#")
      window.location.href = url
      return
    }
    this.getTempalte()
  },
  methods: {  
    getTempalte(){
      var ths = this;   
      ths.$post(
        "/Shop/StoreServer/GetShopsBrandStoreTemplate",{shopId: this.shopId}
      ).then(function(res) {
        if(!res.IsSuccess){
        }else{          
          ths.templateInfo = res.Data;
          ths.$refs.head.UpdateTitle(res.Data.ShopName)
          ths.loaded = false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    getProductName(proItem){
      var proName = proItem.ProductName
      var attrName = proItem.AttrName
      if(!proName){
        proName = ''
      }
      if(!attrName){
        attrName = ''
      }

      return (proName +" " + attrName).length>20?(proName +" " + attrName).substr(0,20)+"...":(proName +" " + attrName)
    }
  }
}
</script>

  
<style>

       .brandStoreIndexPage .banner-area {
            width:100%;
            overflow:hidden;
        }
            .brandStoreIndexPage .banner-area .banner-list {
                width:100%;
                margin:0 auto;
                overflow:hidden;
            }
              .brandStoreIndexPage   .banner-area .banner-list img {
                    display:block;
                    width:100%;
                }
       .brandStoreIndexPage  .main-area {
            width:100%;
            overflow:hidden;
            padding-bottom:60px;
        }
          .brandStoreIndexPage   .main-area .button-list {
                margin:0 auto;
                overflow:hidden;
                background:white;
            }
              .brandStoreIndexPage   .main-area .button-list .button {
                    display:block;
                    width:100%;
                }
           .brandStoreIndexPage  .main-area .model {
                width:100%;
                margin:0 auto;
                overflow:hidden;
            }
                .brandStoreIndexPage  .main-area .model img {
                    width:100%;
                    display:block;
                }
           .brandStoreIndexPage  .main-area .product-row {
            }
               .brandStoreIndexPage  .main-area .product-row .product-item {
                    width:50%;
                    float:left;
                    padding-bottom:50px;
                }
                 .brandStoreIndexPage    .main-area .product-row .product-item .content {
                        width:98%;
                        float:left;
                    }
                   .brandStoreIndexPage  .main-area .product-row .product-item.right .content {                        
                        float:right;
                    }
                 .brandStoreIndexPage    .main-area .product-row .product-item .name {
                        font-size:14px;
                        line-height:16px;
                        padding:10px 6px 2px;
                        height: 32px;
                    }
                   .brandStoreIndexPage  .main-area .product-row .product-item .price {
                        font-size:16px;
                        color:red;
                        text-align:center;
                        padding:4px 0;
                    }
                      .brandStoreIndexPage   .main-area .product-row .product-item .price span {
                            font-size:12px;
                        }
                   .brandStoreIndexPage  .main-area .product-row .product-item .link-btn {
                        background:red;
                        width:100px;
                        height:24px;
                        text-align:center;
                        margin:15px auto 0;
                        display:block;
                        color:white;
                    }
           .brandStoreIndexPage  .main-area .model .btn-shop {
                background:#666;
                height:60px;
                line-height:60px;
                text-align:center;
                color:white;
                display:block;
                width:100%;
                position:fixed;
                bottom:0;
            }
</style>



// WEBPACK FOOTER //
// src/pages/brandStore/index.vue